import BlogPost from "../../../../src/templates/blog-post";
import { graphql } from 'gatsby';
import CodeExample from "../../../../src/components/CodeExample";
import CanIUse from "../../../../src/components/CanIUse";
import * as React from 'react';
export default {
  BlogPost,
  graphql,
  CodeExample,
  CanIUse,
  React
};